<template>
	<AsiCardDetail :title="$t('customer.defaultShipmentType')" :icon="icons.shipmentType"
	               :show-action-button="!readonly" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry :icon="icons.shipmentType" :label="$t('customer.defaultShipmentType')"
		                    :value="defaultShimpmentTypeNameTranslated" />

		<CustomerUpdateDefaultShipmentTypeDialog v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen"
		                                         :customer="customer" @cancel="updateDialog.close()"
		                                         @save="updateDialog.close(); change();" />
	</AsiCardDetail>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import Icon from "@/plugins/icons";
	import DialogHandler from "@/components/common/DialogHandler";
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import {ICustomerShop} from "@/models/customer/CustomerShopModels";
	import {ICustomerAdmin} from "@/models/customer/CustomerAdminModels";
	import TranslatedValueHelper from "@/models/translated-value/TranslatedValueHelper";
	import CustomerUpdateDefaultShipmentTypeDialog
		from "@/components/customer/shop/CustomerUpdateDefaultShipmentTypeDialog.vue";

	@Component({
		components: {CustomerUpdateDefaultShipmentTypeDialog, AsiCardDetailEntry, AsiCardDetail}
	})
	export default class CustomerCardDefaultShipmentType extends Vue {

		@Prop({type: Object, required: true})
		public customer!: ICustomerShop

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private updateDialog: DialogHandler = new DialogHandler();
		private icons = Icon;

		private get defaultShimpmentTypeNameTranslated(): string | null {
			if (this.customer.defaultShipmentType?.name){
				return TranslatedValueHelper.get(this.customer.defaultShipmentType.name, this.$i18n.locale);
			}
			return null;
		}

		@Emit('change')
		public change(): void {
			return;
		}
	}
</script>

<style scoped lang="scss">

</style>
